/* Judge.me keeps its native 1–5 values and submission flow. Only UI labels change. */
(() => {
  const script = document.currentScript;
  const singular = script?.dataset.spurSingular || 'spur';
  const plural = script?.dataset.spurPlural || 'spurs';
  const ratingLabel = script?.dataset.spurRating || 'Spur rating';
  const controls = '.jdgm-write-review-modal__stars button.jdgm-star[data-alt]';
  let scheduled = false;

  function labelRatings() {
    scheduled = false;
    document.querySelectorAll(controls).forEach((button) => {
      const value = button.getAttribute('data-alt');
      if (!/^[1-5]$/.test(value || '')) return;
      const label = `${value} ${value === '1' ? singular : plural}`;
      // data-alt is Judge.me's score input. Never replace it with a text label.
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      if (button.getAttribute('title') !== label) button.setAttribute('title', label);
      if (button.dataset.gwSpurLabel !== label) button.dataset.gwSpurLabel = label;
    });
    document.querySelectorAll('.jdgm-write-review-modal__stars').forEach((group) => {
      if (group.getAttribute('aria-label') !== ratingLabel) group.setAttribute('aria-label', ratingLabel);
    });
  }

  function scheduleLabels() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(labelRatings);
  }

  labelRatings();
  // Judge.me mounts the form after its widget is loaded and can recreate its controls.
  new MutationObserver(scheduleLabels).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label', 'title', 'data-alt'],
  });
})();
